<template>
  <div>
    <vue-headful :title="getPageTitle" description="Description goes here" />
    <div
      class="class-document-section base-type-layout"
      :class="account_type === 'school' ? 'school-top' : ''"
    >
      <!-- BREADCRUMB -->
      <BreadCrumb
        :item_one="current_class_name"
        item_three="Discussions"
        :current_page="0"
        :total_page="0"
        :show_nav="false"
        item_two="Library"
        :item_two_link="accountType + 'Library'"
      ></BreadCrumb>
      <!-- BREADCRUMB -->

      <div class="container px-1 mt-5">
        <div class="row">
          <!-- CLASS BRANCH INFO COLUMN -->
          <div class="col-12 col-md-3 col-lg-3 left-layout">
            <!-- TEACHER CLASSES COMPONENT -->
            <TeacherClassCard
              v-if="account_type === 'teacher'"
            ></TeacherClassCard>

            <MembersCard
              v-else-if="account_type === 'school'"
              @updateTeacher="num_counter++"
            >
              <!-- LOADER -->
              <div
                class="loader d-flex justify-content-center align-items-center my-4"
                v-if="teacher_count === null"
              >
                <div class="avatar">
                  <span
                    class="icon-dotted-spinner flex-center font-22 border_grey_dark animate mr-2"
                  ></span>
                </div>
                <div class="border_grey_dark font-13">Loading Teachers ...</div>
              </div>
              <!-- LOADER -->
              <div slot="teacher__content" v-else>
                <!-- CONTENT TEACHER LIST -->
                <MembersTeacherRow
                  v-if="teacher_count > 0"
                  :teachers_list="teacher_data"
                  @toggleTeacher="toggleTeacherModal"
                ></MembersTeacherRow>

                <!-- EMPTY TEACHER LIST -->
                <div class="teacher-list-empty mb-3">
                  <MembersEmptyTeacherRow
                    v-if="teacher_count === 0"
                    @toggleTeacher="toggleTeacherModal"
                  ></MembersEmptyTeacherRow>
                </div>
              </div>
            </MembersCard>
            <!-- MEMBERS CARD COMPONENT -->
          </div>
          <!-- CLASS BRANCH INFO COLUMN -->

          <!-- CLASS DISCUSSIONS -->
          <div class="col-12 col-md-9 col-lg-9 right-layout">
            <!-- TITLE ROW -->
            <div
              class="title-row d-flex justify-content-between align-items-center nowrap"
            >
              <!-- TEXT TITLE -->
              <div class="text-title font-weight-bold color_text">
                <router-link
                  :to="{name: accountType + 'Library'}"
                  class="icon icon-arrow-left color_text font-20 position-relative pointer mr-2 font-weight-400 d-md-none"
                  style="top: 3px"
                  title="Go Back"
                ></router-link>

                Discussions
              </div>

              <div>
                <!-- FILTER DISCUSSIONS -->
                <div
                  v-if="false"
                  class="avatar brand_primary_bg pointer ml-2 hint--primary hint--rounded hint--bottom"
                  aria-label="Filter Discussions"
                  style="overflow: unset"
                  @click="toggleFilterModal"
                >
                  <span
                    class="icon-search flex-center brand_white font-18"
                  ></span>
                </div>
                <!-- FILTER DISCUSSIONS -->
              </div>
            </div>

            <div class="row" v-if="false">
              <div class="col-12">
                <PostInputCardNew
                  :fullname="getAuthUser.full_name"
                ></PostInputCardNew>
              </div>
            </div>

            <div class="row">
              <!-- POSTS SECTION -->
              <div
                class="col-12 col-md-7 order-2 order-lg-1 discussion-component"
              >
                <!-- DISCUSSION COMPONENTS -->
                <div class="content-post-section">
                  <transition-group name="fade" mode="in-out">
                    <template v-if="is_fetching">
                      <SkeletonPostBlock key="1"></SkeletonPostBlock>
                      <SkeletonPostBlock key="2"></SkeletonPostBlock>
                    </template>

                    <template v-else>
                      <PostBlock
                        key="2"
                        :posts="posts"
                        v-if="posts.length > 0"
                      ></PostBlock>

                      <div
                        class="position-relative"
                        style="top: 150px"
                        key="3"
                        v-if="posts.length === 0"
                      >
                        <EmptyContent
                          display_img="EmptyHomework.png"
                          display_text="There are currently no discussions in this class"
                          :show_button="false"
                          :show_empty="true"
                        />
                      </div>
                    </template>
                  </transition-group>
                </div>

                <!-- INFINITE SCROLLER -->
                <template v-if="!infinite_scroll_end || is_fetching">
                  <SkeletonPostBlock
                    v-if="posts.length"
                    v-observe-visibility="{
                      callback: fetchMorePost,
                      throttle: 300,
                    }"
                  />
                </template>
                <!-- INFINITE SCROLLER -->
              </div>

              <!-- UPCOMING EVENTS -->
              <div
                class="col-12 col-md-5 order-1 order-lg-2 participant-component"
              >
                <DiscussionBlock v-if="false"></DiscussionBlock>
              </div>
            </div>
          </div>
          <!-- CLASS DISCUSSIONS -->
        </div>
      </div>
    </div>

    <!-- MODAL COMPONENTS -->
    <AddTeacherModal
      v-if="teacher_modal"
      @closeTriggered="toggleTeacherModal"
    ></AddTeacherModal>
    <!-- MODAL COMPONENTS -->
  </div>
</template>

<script>
import { capitalizeFirstLetter } from "@/scripts/utilities";
import { mapGetters, mapActions } from "vuex";
import BreadCrumb from "@/components/globalComps/BreadCrumb";
import TeachersInClass from "@/scripts/mixins/TeachersInClass";
import MembersCard from "@/components/classComps/studentSideBar/MembersCard";
import MembersEmptyTeacherRow from "@/components/classComps/studentSideBar/MembersEmptyTeacherRow";
import PostInputCardNew from "@/components/classComps/feeds/PostInputCardNew";
import TeacherClassCard from "@/components/classComps/teacherSideBar/TeacherClassCard";
import EmptyContent from "@/components/globalComps/EmptyContent";
import SkeletonPostBlock from "@/components/classComps/feeds/SkeletonPostBlock";
import PostBlock from "@/components/classComps/feeds/PostBlock";
import DiscussionBlock from "@/components/classComps/library/DiscussionBlock";
import { EventBus } from "@/scripts/event-bus.js";

const MembersTeacherRow = () => ({
  component: import(
    /* webpackChunkName: "MembersTeacherRow" */ "@/components/classComps/studentSideBar/MembersTeacherRow"
  ),
  loading: MembersEmptyTeacherRow,
  error: MembersEmptyTeacherRow,
  delay: 300,
  timeout: 7000,
});

export default {
  name: "Discussions",

  components: {
    BreadCrumb,
    MembersCard,
    MembersEmptyTeacherRow,
    MembersTeacherRow,
    TeacherClassCard,
    PostInputCardNew,
    PostBlock,
    SkeletonPostBlock,
    EmptyContent,
    DiscussionBlock,
    AddTeacherModal: () =>
      import(
        /* webpackChunkName: "AddTeacherModal" */ "@/components/modalComps/schoolModals/AddTeacherModal"
      ),
  },

  mixins: [TeachersInClass],

  computed: {
    ...mapGetters(["getAuthUser", "getCurrentClass"]),

    accountType() {
      if (this.account_type === "school") return capitalizeFirstLetter("class");
      else return capitalizeFirstLetter(this.account_type);
    },

    getPageTitle() {
      return `Class Discussions | ${capitalizeFirstLetter(this.account_type)}`;
    },
  },

  data() {
    return {
      account_type: this.$route.path.split("/")[1],
      filter_modal: false,
      teacher_modal: false,

      class_id: "",

      posts: [],
      post_count: 0,

      page: 1,
      page_end: 0,
      infinite_scroll_end: false,
      is_fetching: true,

      current_class_name: "Class...",
    };
  },

  watch: {
    $route: {
      handler(newVal) {
        if (newVal) {
          this.getClassName();
          this.fetchLatestPost();
        }
      },
      immediate: true, // make this watch function is called when component created
    },
  },

  created() {
    EventBus.$on("event-bus-remount-post-list", this.fetchLatestPost);
    EventBus.$on("event-bus-extract-post", this.extractDeletedPostFromList);
  },

  mounted() {
    this.getClassName();
  },

  methods: {
    ...mapActions(["getFeeds"]),

    // GET CURRENT CLASS NAME
    async getClassName() {
      // SCHOOL ACCOUNT
      if (this.account_type === "school") {
        let query = await this.$store.dispatch(
          "getSingleClass",
          this.$route.params.id
        );
        this.current_class_name = query.data.class_name;
      }
      // TEACHER ACCOUNT
      else if (this.account_type === "teacher") {
        let query = await this.$store.dispatch(
          "getClassDetailsByID",
          this.$route.params.id
        );
        this.current_class_name = query.data.data.class_name;
      }
    },

    async fetchLatestPost() {
      this.posts = [];
      this.page = 1;
      this.is_fetching = true;
      this.page_end = 0;
      this.infinite_scroll_end = false;
      this.class_id = this.$route.params.id;

      // FETCH FEEDS
      this.getPosts();
    },

    getPosts() {
      this.getFeeds({
        pageNumber: this.page,
        id: this.class_id,
        type: "post",
      })
        .then((response) => {
          if (response.code === 200) {
            // console.log(response.data);
            this.posts.push(...response.data);

            this.is_fetching = false;
            this.page_end = response.pagination.pageCount;
          } else {
            this.posts = [];
            this.is_fetching = false;
          }
        })
        .catch((err) => console.log(err));
    },

    fetchMorePost(isVisible) {
      if (!isVisible) return; // CHECK SCROLLING VISIBILITY

      // CHECK IF PAGE IS EQAUL TO PAGE COUNT
      if (this.page === this.page_end) {
        this.infinite_scroll_end = true;
        return;
      }
      this.page += 1; //INCREASE PAGE NUMBER

      this.getPosts();
    },

    // EXTRACT DELETED POST
    extractDeletedPostFromList(id) {
      this.posts = this.posts.filter((post) => {
        return post.id !== id;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.class-document-section {
  .right-layout {
    @include breakpoint_max(lg) {
      padding-left: 30px;
      padding-right: 0px;
    }

    @include breakpoint_max(md) {
      margin-bottom: 80px;
      padding-left: 15px;
      padding-right: 15px;
    }

    .title-row {
      margin-bottom: 40px;

      .text-title {
        font-size: 21px;
        line-height: 29px;

        @include breakpoint_max(sm) {
          font-size: 17px;
        }
        @include breakpoint_max(xs) {
          font-size: 16px;
        }
      }

      .avatar {
        @include equal_min_edge(35);
      }
    }

    .filter-row {
      padding-bottom: 10px;
      margin-bottom: 20px;
      border-bottom: 1px solid $border_grey;

      .file-count,
      .filter {
        font-size: 13px;
        line-height: 16px;
      }
    }

    .discussion-component {
      min-width: 63%;
      max-width: 63%;
      padding-left: 15px;
      padding-right: 15px;
      margin-bottom: 40px;

      @include breakpoint_max(lg) {
        min-width: 100%;
        max-width: 100%;
      }
    }

    .participant-component {
      min-width: 36%;
      max-width: 36%;
      padding-right: 5px;

      @include breakpoint_max(lg) {
        min-width: 100%;
        max-width: 100%;
        padding-right: 15px;
        margin-bottom: 20px;
      }
    }
  }
}

.school-top {
  top: 115px !important;
}
</style>
